<template>
  <span
    v-if="isShowOption"
    :id="idItem"
    :data-cy="dataCyId"
    :class="`custom-drop-down-item tw-whitespace-nowrap basic-text ${padding} ${
      props.style
    }-text ${addIcon ? 'sort-text tw-items-center' : ''} ${
      isLastItem ? '!tw-border-b-0' : ''
    } ${props.styleText} ${customClass} hover:tw-bg-[#F2F8FF80]`"
  >
    <span :class="`${customTextClass}`">
      {{ getUiText(props.idText) }}
      <VendorAssessmentChecklistStatusTag
        v-if="tagStatus && tagStatusId"
        :is-archived="tagIsArchived"
        :checklist-status="tagStatus"
        :checklist-status-id="tagStatusId"
        :is-loading="false"
      />
    </span>
    <upArrowVectorIcon
      v-if="addIcon && transFormRotate === 90"
      class="tw-ml-2 tw-mb-[2px]"
    />
    <downArrowVectorIcon
      v-if="addIcon && transFormRotate === -90"
      class="tw-ml-2 tw-mb-[2px]"
    />
    <ArrowRightIcon v-if="arrowIconStyle" :class="`${arrowIconStyle}`" />
  </span>
</template>

<script setup lang="ts">
import store from "@/store";
import utilities from "@/utils/utilities";
import { computed } from "vue";

import upArrowVectorIcon from "@/components/svgs/upArrowVectorIcon.vue";
import downArrowVectorIcon from "@/components/svgs/downArrowVectorIcon.vue";
import ArrowRightIcon from "@/components/svgs/arrowRightIcon.vue";
import VendorAssessmentChecklistStatusTag from "../vendor/vendorAssessmentChecklistStatusTag.vue";

const props = defineProps({
  idText: {
    type: String,
    required: true,
  },
  style: {
    type: String,
    default: "normal",
  },
  addIcon: {
    type: Boolean,
    default: false,
  },
  transFormRotate: {
    type: Number,
    default: 90,
  },
  isLastItem: {
    type: Boolean,
    default: false,
  },
  styleText: {
    type: String,
    default: "",
  },
  padding: {
    type: String,
    default: "tw-p-[15px]",
  },
  idItem: {
    type: String,
    default: "",
  },
  arrowIconStyle: {
    type: String,
    default: "",
  },
  customClass: {
    type: String,
    default: "",
  },
  customTextClass: {
    type: String,
    default: "",
  },
  tagIsArchived: {
    type: Boolean,
    default: false,
  },
  tagStatus: {
    type: String,
    default: "",
  },
  tagStatusId: {
    type: String,
    default: "",
  },
  dataCyId: {
    type: String,
    default: "",
  },
  isShowOption: {
    type: Boolean,
    default: true,
  },
});

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};
</script>

<style scoped>
.basic-text {
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: #211f58;
  line-height: 130%;
  font-family: "Poppins";
}

.normal-text {
  color: #211f58;
  border-bottom: 1px solid #eff0f1;
}

.danger-text {
  color: #f7553c;
}

.disabled-text {
  color: #dbdbdb;
}
</style>
